import { Link as RouterLink } from "react-router-dom";
import { Typography } from "@mui/material";

const BreadcrumbItem = ({ link, ...props }) => (
  <Typography {...props} component={link ? RouterLink : undefined} to={link} />
);

export default BreadcrumbItem;
